import {
  DateValidationFunction,
  DateValidationResult,
} from '../components/common/DateField'

import dayjs from 'dayjs'

export const createPastDateValidation = (
  errorMessage?: string
): DateValidationFunction => {
  return (date: any): DateValidationResult => {
    if (!date) return { isValid: true }

    const today = dayjs().startOf('day')
    const selectedDate = dayjs(date).startOf('day')

    return {
      isValid: selectedDate.isBefore(today),
      errorMessage: errorMessage || 'Date must be in the past',
    }
  }
}

export const createFutureOrCurrentDateValidation = (
  errorMessage?: string
): DateValidationFunction => {
  return (date: any): DateValidationResult => {
    if (!date) return { isValid: true }

    const today = dayjs().startOf('day')
    const selectedDate = dayjs(date).startOf('day')

    return {
      isValid: selectedDate.isAfter(today) || selectedDate.isSame(today),
      errorMessage: errorMessage || 'Date must not be in past',
    }
  }
}
